/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteRouteImport } from './routes/_index/route'
import { Route as VerificarCertificadoRouteImport } from './routes/verificarCertificado'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexIndexRouteImport } from './routes/_index/index'
import { Route as IndexDashboardRouteImport } from './routes/_index/dashboard'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as IndexSecurityRouteRouteImport } from './routes/_index/security/route'
import { Route as IndexDocumentsRouteRouteImport } from './routes/_index/documents/route'
import { Route as IndexCuentaRouteRouteImport } from './routes/_index/cuenta/route'
import { Route as IndexAdminRouteRouteImport } from './routes/_index/admin/route'
import { Route as IndexCuentaIndexRouteImport } from './routes/_index/cuenta/index'
import { Route as IndexSecurityUsersRouteImport } from './routes/_index/security/users'
import { Route as IndexSecurityEmailRouteImport } from './routes/_index/security/email'
import { Route as IndexSecurityApiKeysRouteImport } from './routes/_index/security/api-keys'
import { Route as IndexDocumentsTemplatesRouteImport } from './routes/_index/documents/templates'
import { Route as IndexDocumentsSignRouteImport } from './routes/_index/documents/sign'
import { Route as IndexCuentaPerfilRouteImport } from './routes/_index/cuenta/perfil'
import { Route as IndexCuentaCambiarContrasenaRouteImport } from './routes/_index/cuenta/cambiarContrasena'
import { Route as IndexAdminUniversitiesRouteImport } from './routes/_index/admin/universities'
import { Route as IndexAdminFacultiesRouteImport } from './routes/_index/admin/faculties'
import { Route as IndexAdminCareersRouteImport } from './routes/_index/admin/careers'

const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/_index',
  getParentRoute: () => rootRouteImport,
} as any)
const VerificarCertificadoRoute = VerificarCertificadoRouteImport.update({
  id: '/verificarCertificado',
  path: '/verificarCertificado',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexIndexRoute = IndexIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IndexRouteRoute,
} as any)
const IndexDashboardRoute = IndexDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => IndexRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const IndexSecurityRouteRoute = IndexSecurityRouteRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => IndexRouteRoute,
} as any)
const IndexDocumentsRouteRoute = IndexDocumentsRouteRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => IndexRouteRoute,
} as any)
const IndexCuentaRouteRoute = IndexCuentaRouteRouteImport.update({
  id: '/cuenta',
  path: '/cuenta',
  getParentRoute: () => IndexRouteRoute,
} as any)
const IndexAdminRouteRoute = IndexAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => IndexRouteRoute,
} as any)
const IndexCuentaIndexRoute = IndexCuentaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IndexCuentaRouteRoute,
} as any)
const IndexSecurityUsersRoute = IndexSecurityUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => IndexSecurityRouteRoute,
} as any)
const IndexSecurityEmailRoute = IndexSecurityEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => IndexSecurityRouteRoute,
} as any)
const IndexSecurityApiKeysRoute = IndexSecurityApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => IndexSecurityRouteRoute,
} as any)
const IndexDocumentsTemplatesRoute = IndexDocumentsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => IndexDocumentsRouteRoute,
} as any)
const IndexDocumentsSignRoute = IndexDocumentsSignRouteImport.update({
  id: '/sign',
  path: '/sign',
  getParentRoute: () => IndexDocumentsRouteRoute,
} as any)
const IndexCuentaPerfilRoute = IndexCuentaPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => IndexCuentaRouteRoute,
} as any)
const IndexCuentaCambiarContrasenaRoute =
  IndexCuentaCambiarContrasenaRouteImport.update({
    id: '/cambiarContrasena',
    path: '/cambiarContrasena',
    getParentRoute: () => IndexCuentaRouteRoute,
  } as any)
const IndexAdminUniversitiesRoute = IndexAdminUniversitiesRouteImport.update({
  id: '/universities',
  path: '/universities',
  getParentRoute: () => IndexAdminRouteRoute,
} as any)
const IndexAdminFacultiesRoute = IndexAdminFacultiesRouteImport.update({
  id: '/faculties',
  path: '/faculties',
  getParentRoute: () => IndexAdminRouteRoute,
} as any)
const IndexAdminCareersRoute = IndexAdminCareersRouteImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => IndexAdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/verificarCertificado': typeof VerificarCertificadoRoute
  '/admin': typeof IndexAdminRouteRouteWithChildren
  '/cuenta': typeof IndexCuentaRouteRouteWithChildren
  '/documents': typeof IndexDocumentsRouteRouteWithChildren
  '/security': typeof IndexSecurityRouteRouteWithChildren
  '/sign-in': typeof AuthSignInRoute
  '/dashboard': typeof IndexDashboardRoute
  '/': typeof IndexIndexRoute
  '/admin/careers': typeof IndexAdminCareersRoute
  '/admin/faculties': typeof IndexAdminFacultiesRoute
  '/admin/universities': typeof IndexAdminUniversitiesRoute
  '/cuenta/cambiarContrasena': typeof IndexCuentaCambiarContrasenaRoute
  '/cuenta/perfil': typeof IndexCuentaPerfilRoute
  '/documents/sign': typeof IndexDocumentsSignRoute
  '/documents/templates': typeof IndexDocumentsTemplatesRoute
  '/security/api-keys': typeof IndexSecurityApiKeysRoute
  '/security/email': typeof IndexSecurityEmailRoute
  '/security/users': typeof IndexSecurityUsersRoute
  '/cuenta/': typeof IndexCuentaIndexRoute
}
export interface FileRoutesByTo {
  '/verificarCertificado': typeof VerificarCertificadoRoute
  '/admin': typeof IndexAdminRouteRouteWithChildren
  '/documents': typeof IndexDocumentsRouteRouteWithChildren
  '/security': typeof IndexSecurityRouteRouteWithChildren
  '/sign-in': typeof AuthSignInRoute
  '/dashboard': typeof IndexDashboardRoute
  '/': typeof IndexIndexRoute
  '/admin/careers': typeof IndexAdminCareersRoute
  '/admin/faculties': typeof IndexAdminFacultiesRoute
  '/admin/universities': typeof IndexAdminUniversitiesRoute
  '/cuenta/cambiarContrasena': typeof IndexCuentaCambiarContrasenaRoute
  '/cuenta/perfil': typeof IndexCuentaPerfilRoute
  '/documents/sign': typeof IndexDocumentsSignRoute
  '/documents/templates': typeof IndexDocumentsTemplatesRoute
  '/security/api-keys': typeof IndexSecurityApiKeysRoute
  '/security/email': typeof IndexSecurityEmailRoute
  '/security/users': typeof IndexSecurityUsersRoute
  '/cuenta': typeof IndexCuentaIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_index': typeof IndexRouteRouteWithChildren
  '/verificarCertificado': typeof VerificarCertificadoRoute
  '/_index/admin': typeof IndexAdminRouteRouteWithChildren
  '/_index/cuenta': typeof IndexCuentaRouteRouteWithChildren
  '/_index/documents': typeof IndexDocumentsRouteRouteWithChildren
  '/_index/security': typeof IndexSecurityRouteRouteWithChildren
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_index/dashboard': typeof IndexDashboardRoute
  '/_index/': typeof IndexIndexRoute
  '/_index/admin/careers': typeof IndexAdminCareersRoute
  '/_index/admin/faculties': typeof IndexAdminFacultiesRoute
  '/_index/admin/universities': typeof IndexAdminUniversitiesRoute
  '/_index/cuenta/cambiarContrasena': typeof IndexCuentaCambiarContrasenaRoute
  '/_index/cuenta/perfil': typeof IndexCuentaPerfilRoute
  '/_index/documents/sign': typeof IndexDocumentsSignRoute
  '/_index/documents/templates': typeof IndexDocumentsTemplatesRoute
  '/_index/security/api-keys': typeof IndexSecurityApiKeysRoute
  '/_index/security/email': typeof IndexSecurityEmailRoute
  '/_index/security/users': typeof IndexSecurityUsersRoute
  '/_index/cuenta/': typeof IndexCuentaIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/verificarCertificado'
    | '/admin'
    | '/cuenta'
    | '/documents'
    | '/security'
    | '/sign-in'
    | '/dashboard'
    | '/'
    | '/admin/careers'
    | '/admin/faculties'
    | '/admin/universities'
    | '/cuenta/cambiarContrasena'
    | '/cuenta/perfil'
    | '/documents/sign'
    | '/documents/templates'
    | '/security/api-keys'
    | '/security/email'
    | '/security/users'
    | '/cuenta/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/verificarCertificado'
    | '/admin'
    | '/documents'
    | '/security'
    | '/sign-in'
    | '/dashboard'
    | '/'
    | '/admin/careers'
    | '/admin/faculties'
    | '/admin/universities'
    | '/cuenta/cambiarContrasena'
    | '/cuenta/perfil'
    | '/documents/sign'
    | '/documents/templates'
    | '/security/api-keys'
    | '/security/email'
    | '/security/users'
    | '/cuenta'
  id:
    | '__root__'
    | '/_auth'
    | '/_index'
    | '/verificarCertificado'
    | '/_index/admin'
    | '/_index/cuenta'
    | '/_index/documents'
    | '/_index/security'
    | '/_auth/sign-in'
    | '/_index/dashboard'
    | '/_index/'
    | '/_index/admin/careers'
    | '/_index/admin/faculties'
    | '/_index/admin/universities'
    | '/_index/cuenta/cambiarContrasena'
    | '/_index/cuenta/perfil'
    | '/_index/documents/sign'
    | '/_index/documents/templates'
    | '/_index/security/api-keys'
    | '/_index/security/email'
    | '/_index/security/users'
    | '/_index/cuenta/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  IndexRouteRoute: typeof IndexRouteRouteWithChildren
  VerificarCertificadoRoute: typeof VerificarCertificadoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_index': {
      id: '/_index'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verificarCertificado': {
      id: '/verificarCertificado'
      path: '/verificarCertificado'
      fullPath: '/verificarCertificado'
      preLoaderRoute: typeof VerificarCertificadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_index/': {
      id: '/_index/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexIndexRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/dashboard': {
      id: '/_index/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof IndexDashboardRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_index/security': {
      id: '/_index/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof IndexSecurityRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/documents': {
      id: '/_index/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof IndexDocumentsRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/cuenta': {
      id: '/_index/cuenta'
      path: '/cuenta'
      fullPath: '/cuenta'
      preLoaderRoute: typeof IndexCuentaRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/admin': {
      id: '/_index/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof IndexAdminRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/cuenta/': {
      id: '/_index/cuenta/'
      path: '/'
      fullPath: '/cuenta/'
      preLoaderRoute: typeof IndexCuentaIndexRouteImport
      parentRoute: typeof IndexCuentaRouteRoute
    }
    '/_index/security/users': {
      id: '/_index/security/users'
      path: '/users'
      fullPath: '/security/users'
      preLoaderRoute: typeof IndexSecurityUsersRouteImport
      parentRoute: typeof IndexSecurityRouteRoute
    }
    '/_index/security/email': {
      id: '/_index/security/email'
      path: '/email'
      fullPath: '/security/email'
      preLoaderRoute: typeof IndexSecurityEmailRouteImport
      parentRoute: typeof IndexSecurityRouteRoute
    }
    '/_index/security/api-keys': {
      id: '/_index/security/api-keys'
      path: '/api-keys'
      fullPath: '/security/api-keys'
      preLoaderRoute: typeof IndexSecurityApiKeysRouteImport
      parentRoute: typeof IndexSecurityRouteRoute
    }
    '/_index/documents/templates': {
      id: '/_index/documents/templates'
      path: '/templates'
      fullPath: '/documents/templates'
      preLoaderRoute: typeof IndexDocumentsTemplatesRouteImport
      parentRoute: typeof IndexDocumentsRouteRoute
    }
    '/_index/documents/sign': {
      id: '/_index/documents/sign'
      path: '/sign'
      fullPath: '/documents/sign'
      preLoaderRoute: typeof IndexDocumentsSignRouteImport
      parentRoute: typeof IndexDocumentsRouteRoute
    }
    '/_index/cuenta/perfil': {
      id: '/_index/cuenta/perfil'
      path: '/perfil'
      fullPath: '/cuenta/perfil'
      preLoaderRoute: typeof IndexCuentaPerfilRouteImport
      parentRoute: typeof IndexCuentaRouteRoute
    }
    '/_index/cuenta/cambiarContrasena': {
      id: '/_index/cuenta/cambiarContrasena'
      path: '/cambiarContrasena'
      fullPath: '/cuenta/cambiarContrasena'
      preLoaderRoute: typeof IndexCuentaCambiarContrasenaRouteImport
      parentRoute: typeof IndexCuentaRouteRoute
    }
    '/_index/admin/universities': {
      id: '/_index/admin/universities'
      path: '/universities'
      fullPath: '/admin/universities'
      preLoaderRoute: typeof IndexAdminUniversitiesRouteImport
      parentRoute: typeof IndexAdminRouteRoute
    }
    '/_index/admin/faculties': {
      id: '/_index/admin/faculties'
      path: '/faculties'
      fullPath: '/admin/faculties'
      preLoaderRoute: typeof IndexAdminFacultiesRouteImport
      parentRoute: typeof IndexAdminRouteRoute
    }
    '/_index/admin/careers': {
      id: '/_index/admin/careers'
      path: '/careers'
      fullPath: '/admin/careers'
      preLoaderRoute: typeof IndexAdminCareersRouteImport
      parentRoute: typeof IndexAdminRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface IndexAdminRouteRouteChildren {
  IndexAdminCareersRoute: typeof IndexAdminCareersRoute
  IndexAdminFacultiesRoute: typeof IndexAdminFacultiesRoute
  IndexAdminUniversitiesRoute: typeof IndexAdminUniversitiesRoute
}

const IndexAdminRouteRouteChildren: IndexAdminRouteRouteChildren = {
  IndexAdminCareersRoute: IndexAdminCareersRoute,
  IndexAdminFacultiesRoute: IndexAdminFacultiesRoute,
  IndexAdminUniversitiesRoute: IndexAdminUniversitiesRoute,
}

const IndexAdminRouteRouteWithChildren = IndexAdminRouteRoute._addFileChildren(
  IndexAdminRouteRouteChildren,
)

interface IndexCuentaRouteRouteChildren {
  IndexCuentaCambiarContrasenaRoute: typeof IndexCuentaCambiarContrasenaRoute
  IndexCuentaPerfilRoute: typeof IndexCuentaPerfilRoute
  IndexCuentaIndexRoute: typeof IndexCuentaIndexRoute
}

const IndexCuentaRouteRouteChildren: IndexCuentaRouteRouteChildren = {
  IndexCuentaCambiarContrasenaRoute: IndexCuentaCambiarContrasenaRoute,
  IndexCuentaPerfilRoute: IndexCuentaPerfilRoute,
  IndexCuentaIndexRoute: IndexCuentaIndexRoute,
}

const IndexCuentaRouteRouteWithChildren =
  IndexCuentaRouteRoute._addFileChildren(IndexCuentaRouteRouteChildren)

interface IndexDocumentsRouteRouteChildren {
  IndexDocumentsSignRoute: typeof IndexDocumentsSignRoute
  IndexDocumentsTemplatesRoute: typeof IndexDocumentsTemplatesRoute
}

const IndexDocumentsRouteRouteChildren: IndexDocumentsRouteRouteChildren = {
  IndexDocumentsSignRoute: IndexDocumentsSignRoute,
  IndexDocumentsTemplatesRoute: IndexDocumentsTemplatesRoute,
}

const IndexDocumentsRouteRouteWithChildren =
  IndexDocumentsRouteRoute._addFileChildren(IndexDocumentsRouteRouteChildren)

interface IndexSecurityRouteRouteChildren {
  IndexSecurityApiKeysRoute: typeof IndexSecurityApiKeysRoute
  IndexSecurityEmailRoute: typeof IndexSecurityEmailRoute
  IndexSecurityUsersRoute: typeof IndexSecurityUsersRoute
}

const IndexSecurityRouteRouteChildren: IndexSecurityRouteRouteChildren = {
  IndexSecurityApiKeysRoute: IndexSecurityApiKeysRoute,
  IndexSecurityEmailRoute: IndexSecurityEmailRoute,
  IndexSecurityUsersRoute: IndexSecurityUsersRoute,
}

const IndexSecurityRouteRouteWithChildren =
  IndexSecurityRouteRoute._addFileChildren(IndexSecurityRouteRouteChildren)

interface IndexRouteRouteChildren {
  IndexAdminRouteRoute: typeof IndexAdminRouteRouteWithChildren
  IndexCuentaRouteRoute: typeof IndexCuentaRouteRouteWithChildren
  IndexDocumentsRouteRoute: typeof IndexDocumentsRouteRouteWithChildren
  IndexSecurityRouteRoute: typeof IndexSecurityRouteRouteWithChildren
  IndexDashboardRoute: typeof IndexDashboardRoute
  IndexIndexRoute: typeof IndexIndexRoute
}

const IndexRouteRouteChildren: IndexRouteRouteChildren = {
  IndexAdminRouteRoute: IndexAdminRouteRouteWithChildren,
  IndexCuentaRouteRoute: IndexCuentaRouteRouteWithChildren,
  IndexDocumentsRouteRoute: IndexDocumentsRouteRouteWithChildren,
  IndexSecurityRouteRoute: IndexSecurityRouteRouteWithChildren,
  IndexDashboardRoute: IndexDashboardRoute,
  IndexIndexRoute: IndexIndexRoute,
}

const IndexRouteRouteWithChildren = IndexRouteRoute._addFileChildren(
  IndexRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  IndexRouteRoute: IndexRouteRouteWithChildren,
  VerificarCertificadoRoute: VerificarCertificadoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
